/* shared/feedback — toast notifications.
   Extracted from shell.jsx (ToastProvider + useToast). ESM. */
import React, { createContext, useContext, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { NexusIcon } from '../ui/NexusIcon';

const ToastCtx = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const push = useCallback((t) => {
    const id = Math.random().toString(36).slice(2);
    setToasts(ts => [...ts, { id, ...t }]);
    setTimeout(() => setToasts(ts => ts.filter(x => x.id !== id)), 3500);
  }, []);
  const container = (
    <div className="nx-toasts">
      {toasts.map(t => (
        <div key={t.id} className={'nx-toast nx-toast-' + (t.tone || 'default')}>
          <NexusIcon name={t.icon || 'Check'} size={16} />
          <div className="nx-toast-body">
            <div className="nx-toast-title">{t.title}</div>
            {t.desc && <div className="nx-toast-desc">{t.desc}</div>}
          </div>
          {t.action && <button className="nx-toast-action">{t.action}</button>}
        </div>
      ))}
    </div>
  );
  return (
    <ToastCtx.Provider value={push}>
      {children}
      {typeof document !== 'undefined' ? createPortal(container, document.body) : container}
    </ToastCtx.Provider>
  );
};

export const useToast = () => useContext(ToastCtx);
